export function createRideOfferClient(transport) {
    return {
        /**
         * The offers an operator is watching
         *
         * Requires scope: ride-offer:read, ride-offer:workload
         */
        getRideOffers(status, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/ride-offers",
                query: { status: status, limit: limit, after: after },
                options,
            });
        },
        /**
         * Create an offer from immutable demand and candidate references
         *
         * Requires scope: ride-offer:create
         */
        postRideOffers(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/ride-offers",
                body,
                options,
            });
        },
        /**
         * One courier's own live offers
         *
         * Requires scope: ride-offer:self, ride-offer:workload
         */
        listDriverRideOffers(driverId, status, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/ride-offers`,
                query: { status: status, limit: limit, after: after },
                options,
            });
        },
        /**
         * Read an authoritative tenant-scoped offer
         *
         * Requires scope: ride-offer:read, ride-offer:workload
         */
        getRideOffers2(offerId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/ride-offers/${encodeURIComponent(offerId)}`,
                options,
            });
        },
        /**
         * Atomically accept before server-authoritative expiry
         *
         * Requires scope: ride-offer:any, ride-offer:respond
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postRideOffersAccept(offerId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/ride-offers/${encodeURIComponent(offerId)}/accept`,
                options,
            });
        },
        /**
         * Reject an offer
         *
         * Requires scope: ride-offer:any, ride-offer:respond
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postRideOffersReject(offerId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/ride-offers/${encodeURIComponent(offerId)}/reject`,
                options,
            });
        },
        /**
         * Record that an offer reached a driver's device
         *
         * Requires scope: ride-offer:workload
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postRideOffersDeliver(offerId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/ride-offers/${encodeURIComponent(offerId)}/deliver`,
                options,
            });
        },
        /**
         * Record that a driver has seen the offer
         *
         * Requires scope: ride-offer:any, ride-offer:respond
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postRideOffersView(offerId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/ride-offers/${encodeURIComponent(offerId)}/view`,
                options,
            });
        },
        /**
         * Withdraw an offer that should no longer be answered
         *
         * Requires scope: ride-offer:workload
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postRideOffersCancel(offerId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/ride-offers/${encodeURIComponent(offerId)}/cancel`,
                options,
            });
        },
        /**
         * Confirm an acceptance may establish an assignment, evaluating its expiry
         *
         * Requires scope: ride-offer:workload
         */
        postRideOffersValidateAccepted(offerId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/ride-offers/${encodeURIComponent(offerId)}/validate-accepted`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
        /**
         * Expire ride offers whose deadline has passed
         *
         * Requires scope: ride-offer:workload
         */
        expireDueRideOffers(body, options) {
            return transport.request({
                method: "POST",
                path: "/internal/v1/ride-offers/expire",
                body,
                options,
            });
        },
    };
}
//# sourceMappingURL=ride-offer.js.map